import { DASHCOLORS, Icon } from 'bd-web-components'
import {
  PageSubtitle,
  StyledModal,
  CloseButton,
  PageTitle,
  BeforeDiv,
} from './styles'
import { format } from 'date-fns'
import { useCallback, useEffect, useState } from 'react'
import { useAdvanceInvoice } from '../../hooks/advance-invoice'
import useSWRMutation from 'swr/mutation'
import { toast } from 'react-toastify'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { AdvanceCore } from './core-advance'
import { WithdrawCore } from './core-withdraw'

interface CustomMgsProp {
  title: string
  subtitle: string
}
export interface ConfirmationProps {
  customSuccess: CustomMgsProp
  customError: CustomMgsProp
}

export type TransactionData = {
  description: string
  id: number
  price: string
  receiptUrl: string | null
  time: string
  title: string
  type: 'advance' | 'withdraw' | string
  value: string
  valueRaw: string
}

type WithdrawRawData = {
  accountFullNumber: string
  accountIdentifier: string
  accountOwner: string
  accountType: string
  agency: string
  bank: string
  description: string
  nationalRegistration: string
}

export type WithdrawalRequest = {
  description: string
  id: number
  info: string
  receiptUrl: string | null
  status: string
  time: string
  title: string
  type: 'withdraw'
  value: string
  valueRaw: string
  withdrawRawData: WithdrawRawData
}

type ModalProps = {
  isOpen: boolean
  handleClose: () => void
  data: WithdrawalRequest | TransactionData
  eventId: string
  eventName: string
}

export const TransactionItemModal = ({
  isOpen,
  handleClose,
  data,
  eventId,
  eventName,
}: ModalProps) => {
  const time = new Date()
  const [modalData, setModalData] = useState<any>(null)
  const [id, setId] = useState<string>('0')
  const isMobile = useMediaQuery('(max-width: 768px)')
  const { fetcher } = useAdvanceInvoice()
  const { trigger, isMutating } = useSWRMutation(
    {
      id: eventId,
      advanceId: id,
    },
    fetcher
  )

  useEffect(() => {
    if (data !== null) {
      setModalData(data)
      setId(data.id.toString())
    }
  }, [data])

  const handleButtonClick = (event: any) => {
    event.preventDefault()
    onSubmit()
  }

  const onSubmit = useCallback(async () => {
    try {
      const result = await trigger()
      console.log(result)
      const { data } = result
      const { url } = data.data

      if (url) {
        window.open(url, '_blank')
      } else {
        toast.error('A URL não foi encontrada, tente novamente')
      }
    } catch (e) {
      toast.error('Um erro aconteceu, tente novamente')
      console.log(e, 'error')
    }
  }, [trigger])
  const status =
    modalData !== null && modalData.type === 'withdraw'
      ? modalData.status
      : 'ANTECIPADO'

  const date = modalData !== null ? new Date(modalData.time) : time

  const formattedDateTime = format(date, 'dd/MM/yyyy HH:mm')
  return (
    <StyledModal
      isOpen={isOpen}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      {modalData && (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              width: '100%',
            }}
          >
            <div
              style={{
                width: 'max-content',
                flex: 1,
              }}
            >
              <CloseButton onClick={handleClose} type="button">
                <Icon
                  width={20}
                  height={20}
                  iconName={'x'}
                  fill={DASHCOLORS.PRIMARY_BLUE_03}
                  classes="add-account-chevron"
                />
              </CloseButton>
            </div>
          </div>
          <BeforeDiv>
            <div
              style={{
                position: isMobile ? 'relative' : 'absolute',
                top: isMobile ? '-19px' : '33px',
                maxHeight: '30px',
              }}
            >
              <PageSubtitle>
                {formattedDateTime} - STATUS: {status}
              </PageSubtitle>
            </div>
          </BeforeDiv>
          <PageTitle>{eventName}</PageTitle>
          <div>
            <div
              style={{
                backgroundColor: DASHCOLORS.GRAY_SCALE_09,
                height: '85px',
                width: '85px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '30px',
                borderRadius: '50%',
                boxSizing: 'border-box',
              }}
            >
              <Icon
                width={27}
                height={27}
                iconName={
                  modalData.type === 'withdraw' ? 'withdraw' : 'twoSidesArrow'
                }
                fill={DASHCOLORS.PRIMARY_BLUE_03}
                classes="add-account-chevron"
              />
            </div>
          </div>
          {modalData.type === 'advance' && (
            <AdvanceCore
              modalData={modalData}
              isMutating={isMutating}
              onSubmit={handleButtonClick}
            />
          )}
          {modalData.type === 'withdraw' && (
            <WithdrawCore modalData={modalData} />
          )}
        </>
      )}
    </StyledModal>
  )
}
